import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchLoaStats } from "../store/Slices/logSlice";
import * as d3 from "d3";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Header from "./navbar";

const Loadashboard = () => {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const chartRef = useRef();

  const handleFetch = async (e) => {
    e.preventDefault();
    const sDate = startDate.toISOString().split("T")[0];
    const eDate = endDate.toISOString().split("T")[0];

    dispatch(fetchLoaStats({ startDate: sDate, endDate: eDate })).then(
      (response) => {
        if (response?.payload) {
          const logs = response.payload.logs;
          drawChart(logs);
        } else {
          console.error("Failed to fetch LOA stats");
        }
      }
    );
  };

  const drawChart = (logs) => {
    // Aggregate data
    const data = d3
      .rollups(logs, (v) => v.length, (d) => d.country)
      .map(([country, count]) => ({ country, count }));

    // (fix for duplicate y-axis)
    d3.select(chartRef.current).selectAll("*").remove();

    const width = 700;
    const height = 400;
    const margin = { top: 40, right: 30, bottom: 120, left: 60 };

    const svg = d3
      .select(chartRef.current)
      .append("svg")
      .attr("width", width)
      .attr("height", height);

    const chart = svg
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const x = d3
      .scaleBand()
      .domain(data.map((d) => d.country))
      .range([0, width - margin.left - margin.right])
      .padding(0.2);
    const maxCount = d3.max(data, d => d.count);
    const upperBound = Math.ceil(maxCount / 5) * 5;
    const y = d3.scaleLinear()
      .domain([0, upperBound])
      .range([height - margin.top - margin.bottom, 0]);

    // X Axis
    chart
      .append("g")
      .attr("transform", `translate(0,${height - margin.top - margin.bottom})`)
      .call(d3.axisBottom(x))
      .selectAll("text")
      .attr("transform", "rotate(-30)")
      .style("text-anchor", "end")
      .style("font-size", "12px")
      .style("fill", "#555");

    // Y Axis (integer values, single render)
    chart.append("g")
      .call(
        d3.axisLeft(y)
          .tickValues(d3.range(0, upperBound + 1, 5))
          .tickFormat(d3.format("d"))
      )
      .style("font-size", "12px");

    // Bars with animation
    chart
      .selectAll(".bar")
      .data(data)
      .enter()
      .append("rect")
      .attr("class", "bar")
      .attr("x", (d) => x(d.country))
      .attr("width", x.bandwidth())
      .attr("y", y(0))
      .attr("height", 0)
      .attr("fill", "orange")
      .transition()
      .duration(800)
      .attr("y", (d) => y(d.count))
      .attr("height", (d) => y(0) - y(d.count));

    // Tooltip (recreated cleanly every draw)
    const tooltip = d3
      .select(chartRef.current)
      .append("div")
      .attr("class", "tooltip")
      .style("position", "absolute")
      .style("background", "#333")
      .style("color", "#fff")
      .style("padding", "6px 10px")
      .style("border-radius", "5px")
      .style("font-size", "12px")
      .style("visibility", "hidden");

    chart
      .selectAll(".bar")
      .on("mouseover", function (event, d) {
        tooltip.style("visibility", "visible").text(`${d.country}: ${d.count}`);
        d3.select(this).attr("fill", "#f57c00");
      })
      .on("mousemove", (event) => {
        tooltip
          .style("top", `${event.pageY - 40}px`)
          .style("left", `${event.pageX + 10}px`);
      })
      .on("mouseout", function () {
        tooltip.style("visibility", "hidden");
        d3.select(this).attr("fill", "orange");
      });
  };

  return (
    <>
      <Header />
      <div
        style={{
          fontFamily: "Inter, sans-serif",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "30px",
          backgroundColor: "#f9fafc",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "25px 35px",
            borderRadius: "15px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            width: "80%",
            maxWidth: "900px",
          }}
        >
          <h2 style={{ color: "#333", marginBottom: "20px" }}>📊 LOA Dashboard</h2>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "25px",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <label style={{ fontWeight: "500" }}>Start Date:</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="yyyy-MM-dd"
            />
            <label style={{ fontWeight: "500" }}>End Date:</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="yyyy-MM-dd"
            />
            <button
              onClick={handleFetch}
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                padding: "8px 16px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                transition: "background 0.3s",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
            >
              Load Data
            </button>
          </div>

          <div ref={chartRef} style={{ position: "relative" }}></div>
        </div>
      </div>
    </>
  );
};

export default Loadashboard;
